<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 2V22.0001H21.0003V8.62173L15.1144 2H3ZM19.0002 20H5.00013V4.00012H14.0001V10.0002H19.0002V20ZM7.00026 10.0016H12.0003V8.0015H7.00026V10.0016ZM17.7747 8.00009L16.0003 6.00365V8.00009H17.7747ZM17.0003 15.9997H7.00026V17.9999H17.0003V15.9997ZM17.0003 14.0007H7.00026V12.0006H17.0003V14.0007Z"
    />
  </svg>
</template>
